module.exports = __webpack_public_path__ + "assets/img/driver-btn-2d275e9d.png";